<div id="toast" *ngIf="isEnabled" class="fixed flex items-center z-10 bottom-4 left-0 right-0 mx-auto w-max max-w-screen-md p-3 text-white text-xs font-[600] rounded" style="box-shadow: 0px 3px 10px #0000005F;" [ngClass]="toastType">
    <app-svg src="assets/svgs/warning.svg" customClass="mt-[-2px]"
    label="title_goes_here" [stretch]="false" width="15" height="15"></app-svg>
    <span class="px-3">{{ msg }}</span> 
    <app-svg class="cursor-pointer" (click)="disableLoader()" src="assets/svgs/close.svg" customClass="mt-[-2px]"
          label="title_goes_here" [stretch]="false" width="11" height="11" fill="#fff"></app-svg>
 </div>
